import { useState, useEffect } from 'react';
import '../styles/AdminDashboard.css';

export default function AdminDashboard() {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    fetch('/api/dashboard')
      .then(r => r.json())
      .then(data => { if (!data.error) setDatos(data); })
      .catch(() => {})
      .finally(() => setCargando(false));
  }, []);

  if (cargando) return null;
  if (!datos)   return null;

  const { hoy, semana, mes, top_visitados } = datos;

  return (
    <div className="dash-wrap">

      {/* KPIs de ingresos */}
      <div className="dash-kpis">
        <div className="dash-kpi">
          <span className="dash-kpi-label">Hoy</span>
          <span className="dash-kpi-valor">${hoy.total.toLocaleString('es-AR')}</span>
          <span className="dash-kpi-count">{hoy.count} venta{hoy.count !== 1 ? 's' : ''}</span>
        </div>
        <div className="dash-kpi">
          <span className="dash-kpi-label">Esta semana</span>
          <span className="dash-kpi-valor">${semana.total.toLocaleString('es-AR')}</span>
          <span className="dash-kpi-count">{semana.count} venta{semana.count !== 1 ? 's' : ''}</span>
        </div>
        <div className="dash-kpi dash-kpi-mes">
          <span className="dash-kpi-label">Este mes</span>
          <span className="dash-kpi-valor">${mes.total.toLocaleString('es-AR')}</span>
          <span className="dash-kpi-count">{mes.count} venta{mes.count !== 1 ? 's' : ''}</span>
        </div>
      </div>

      {/* Top visitados */}
      {top_visitados.length > 0 && (
        <div className="dash-visitados">
          <span className="dash-visitados-label">👁 Más vistos</span>
          <div className="dash-visitados-lista">
            {top_visitados.map((p, i) => (
              <div key={p._id} className="dash-visitado-item">
                {p.thumb && (
                  <img src={p.thumb} alt={p.nombre} className="dash-visitado-thumb" />
                )}
                <div className="dash-visitado-info">
                  <span className="dash-visitado-pos">{i + 1}</span>
                  <span className="dash-visitado-nombre">{p.nombre}</span>
                  <span className="dash-visitado-vis">{p.visitas} vis.</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

    </div>
  );
}
